const t=t=>t.split("?")[1];export{t as getSearchQueryFromUrl};
